export default {
  nav: {
    home: 'Home',
    manufacturers: 'Manufacturers',
    products: 'Products',
    about: 'About',
    blog: 'Blog',
    faq: 'FAQ',
    contact: 'Contact',
    getQuote: 'Get a Quote',
  },
  langModal: {
    title: 'We Are Global',
    chooseLocation: 'Choose your location',
  },
  header: {
    email: "uk{'@'}gmgautomation.net",
    phone: '+39 040 987 1972',
    language: 'English',
    searchPlaceholder: 'Search by Part Number or Manufacturer',
    noResults: 'No parts found',
    enquiryLink: 'Submit an enquiry',
    enquiryLinkSub: "Can't find your part? Let us know",
  },
  quoteDrawer: {
    title: 'Send an enquiry',
    parts: 'Part Number',
    addPart: 'Add another part',
  },
  home: {
    hero: {
      title: 'Search by part number & find {highlight} and current line automation spare parts',
      highlight: 'obsolete',
      subtitle:
        'Discover our wide range of products for all your needs, including controllers, PLCs, HMIs, motors, encoders, servo drives, inverters, CNC systems and much more',
      searchPlaceholder: 'Enter part number...',
      search: 'Search',
    },
    manufacturers: {
      title: 'Manufacturers',
      subtitle:
        "Our extensive inventory comprises thousands of automation and control components from top-tier OEMs, making it a one-stop solution for your needs. If a part isn't in stock, rest assured our multilingual team will search worldwide to procure the exact component you need at the most competitive price.",
      viewProducts: 'View Products',
      viewAll: 'View all manufacturers',
    },
    whyUs: {
      title: 'Why GMG Automation?',
      subtitle: 'The values that make us a trusted partner for industrial automation',
      quality: {
        title: 'Quality Service',
        description: 'Friendly and experienced customer service to provide fast and efficient solutions.',
      },
      shipping: {
        title: 'Fast Shipping',
        description: 'Same Day Delivery on parts in stock or express shipping from our global network.',
      },
      warranty: {
        title: '12 Months Warranty',
        description:
          'We offer 12 Months Warranty on all parts, whether it’s New, Refurbished, Repaired or in Service-Exchange.',
      },
    },
    services: {
      title: 'Services',
      subtitle: 'Complete solutions for your automation spare part needs',
      learnMore: 'Learn more',
      supply: {
        title: 'Supply',
        description: 'We take care to deliver your part from our stock or from our supplier directly to your door.',
      },
      exchange: {
        title: 'Service-Exchange',
        description: 'We take your faulty unit back in exchange for a heavily discount tested and functioning unit.',
      },
      repair: {
        title: 'Repair',
        description: 'We can repair thousands of products at fixed prices.',
      },
    },
  },
  manufacturers: {
    searchPlaceholder: 'Search manufacturers...',
    noResults: 'No manufacturers found',
    hero: {
      title: 'Manufacturers',
      subtitle: 'See our extensive range of manufacturers and find out about the availability of thousands of products',
      badges: {
        warranty: { title: '12-month Warranty', subtitle: 'On all parts supplied' },
        response: { title: 'Quick Response', subtitle: 'Within 24 hours' },
        delivery: { title: 'Global Delivery', subtitle: 'Worldwide shipping' },
      },
    },
    products: {
      hero: {
        subtitle: "Can't find what you are looking for? Call us or send us an Enquiry",
      },
      searchPlaceholder: 'Search by part number...',
      showingEntries: 'Showing {from}–{to} of {total} parts',
      noResults: 'No parts found',
    },
  },
  about: {
    hero: {
      title: 'Finding solutions for your productivity is our ultimate goal',
      subtitle: 'Finding automation spare part solutions to minimise downtime or long lead times from OEMs',
    },
    values: {
      fast: {
        title: 'Fast',
        desc: "We are known for our prompt response, we pride ourselves on swiftly addressing our customers' needs, ensuring minimal delay in getting your automation systems back to peak performance.",
      },
      friendly: {
        title: 'Friendly',
        desc: "Experience unparalleled customer service with our friendly, dedicated team that's always ready to assist you with a smile, making your journey with us smooth and satisfying.",
      },
      experienced: {
        title: 'Experienced',
        desc: 'Leveraging years of industry experience, we offer expert guidance and quality solutions, making us your trusted partner in automation spare parts provision.',
      },
      reliable: {
        title: 'Reliable',
        desc: 'Reliability is at the core of our operations, providing dependable automation spare part solutions that you can trust, every time.',
      },
    },
    story1: {
      title: 'Our Team has succeeded in understanding the needs of the industry',
      text: 'GMG Automation has at heart the concerns of their customers seeking solutions to their machine breakdowns or need for obsolete spare parts. That’s why we have developed a network worldwide of suppliers to provide solutions that are cost effective and fast.',
    },
    story2: {
      title: 'Creating reliable services to serve them all',
      text: 'With more than 10 years of experience in the Automation industry and a multilingual team at your disposition, we don’t leave you hanging!',
    },
  },
  blog: {
    hero: {
      title: 'Blog',
      subtitle: 'Stay up to date with the latest news and insights from our team',
    },
    empty: 'No articles found.',
    back: 'Back to Blog',
    label: 'Article',
    related: 'Related Articles',
  },
  faq: {
    hero: {
      title: "FAQ's",
      subtitle: 'Read our Frequently Asked Questions',
    },
    search: 'Search frequently asked questions',
    empty: 'No frequently asked questions found.',
  },
  contact: {
    hero: {
      title: 'Contact us',
      subtitle:
        'At GMG Automation, we are more than just automation spare parts resellers; we are your committed partners in success. With a dedicated and multilingual team at your service, we are poised to assist you with any inquiries you might have',
    },
    offices: {
      title: 'Our Offices',
    },
    form: {
      title: 'Get In Touch',
      name: 'Name',
      company: 'Company Name',
      email: 'Email Address',
      nameRequired: 'Name is required.',
      companyRequired: 'Company name is required.',
      emailRequired: 'Email is required.',
      phoneRequired: 'Phone is required.',
      phone: 'Phone Number',
      phonePlaceholder: 'e.g. +44 20 7946 0958',
      message: 'Please tell us details',
      send: 'Send',
      sending: 'Sending...',
      successTitle: 'Message Sent',
      successDetail: 'We will get back to you as soon as possible.',
      errorTitle: 'Error',
      errorDetail: 'Something went wrong. Please try again.',
    },
    plantAddresses: {
      title: 'Address and Bank Details',
      regNumber: 'Company Registration Number',
      phone: 'Phone',
      bankDetails: 'Bank Details',
      beneficiary: 'Beneficiary',
    },
  },
  terms: {
    hero: {
      title: 'Terms & Conditions',
    },
    empty: 'No terms and conditions found.',
  },
  privacy: {
    hero: {
      title: 'Privacy Policy',
    },
    empty: 'No privacy policy found.',
  },
  cookie: {
    hero: {
      title: 'Cookie Policy',
    },
    empty: 'No cookie policy found.',
    banner: {
      message:
        'We use cookies to improve your experience on our website. By continuing to browse, you agree to our use of cookies.',
      learnMore: 'Cookie Policy',
      necessaryOnly: 'Necessary Only',
      acceptAll: 'Accept All',
    },
  },

  product: {
    manufacturer: 'Manufacturer',
    partNumberLabel: 'Part Number',
    noDescription: 'No description available',
    inStock: 'In Stock',
    available: 'Available',
    qty: 'Quantity',
    addToCart: 'Add to Cart',
    addedToCart: 'Added to Cart',
    enquiryTitle: 'Quick Enquiry',
    warrantyText: 'All products come with a standard 12-month warranty.',
    fetchError: 'Failed to load product.',
    trust: {
      warranty: '12-month warranty on all products',
      shipping: 'Fast worldwide shipping',
      support: 'Professional customer support',
    },
    features: {
      quality: 'Quality Product',
      delivery: 'Quick Delivery',
      warranty: '12-Month Warranty',
    },
    tabs: {
      description: 'Description',
      warranty: 'Warranty',
    },
  },

  enquiryForm: {
    companyName: 'Company Name',
    yourName: 'Your Name',
    email: 'Email',
    country: 'Select Country',
    partNumber: 'Part Number',
    quantity: 'Quantity',
    send: 'Send',
    phoneInput: {
      placeholder: 'Phone Number',
      searchPlaceholder: 'Search',
    },
    successTitle: 'Enquiry sent',
    successDetail: 'We will get back to you shortly.',
    errorTitle: 'Something went wrong',
    errorDetail: 'Please try again later.',
  },

  searchEnquiry: {
    title: 'Search results for',
    whatNext: {
      title: 'What happens next?',
      step1Title: '1. Email Confirmation',
      step1Text: 'You will get an email confirming that we have received your enquiry.',
      step2Title: '2. Dedicated Account Manager',
      step2Text: 'One of our team will be in touch to confirm your part(s) specification and condition.',
      step3Title: '3. Your Quote',
      step3Text: 'You will receive a comprehensive quote tailored to your specific needs.',
      legal: 'All orders are subject to product availability.',
      legalLink: 'See our T&Cs.',
      askTeam: 'Ask our team',
      emailLabel: 'Email',
    },
  },

  cart: {
    title: 'Enquiry Cart',
    empty: 'Your cart is empty',
    emptySub: 'Add parts from the product pages to get started',
    browse: 'Browse Parts',
    itemCount: '{count} part | {count} parts',
    partNumber: 'Part Number',
    availability: 'Availability',
    quantity: 'Quantity',
    clearAll: 'Clear all',
    clearTitle: 'Clear Cart',
    clearConfirm: 'Are you sure you want to remove all items from your cart?',
    clear: 'Clear',
    cancel: 'Cancel',
    enquirySubtitle: '{count} part in your enquiry | {count} parts in your enquiry',
    addedTitle: 'Added to cart',
    addedDetail: '{partNumber} has been added to your enquiry cart',
  },

  footer: {
    contact: {
      title: 'More ways to Connect with Us',
      subtitle: 'Contact us via phone or by submitting a form and we will be happy to help you!',
      formTitle: 'Submit a Form Online',
      formSubtitle: "Share your requirements and we'll get back to you within 24 hours.",
      enquiry: 'Enquiry',
      callTitle: 'Call Us',
      callSubtitle: 'Speak with our multilingual team directly.',
    },
    sections: {
      manufacturers: 'Manufacturers',
      quickLinks: 'Quick Links',
      connect: 'Contact',
    },
    actions: {
      whatsapp: 'WhatsApp',
    },
    legal: {
      rights: 'All rights reserved',
      privacy: 'Privacy Policy',
      terms: 'Terms & Conditions',
    },
    recaptcha: 'Protected by reCAPTCHA',
    recaptchaPrivacy: 'Privacy',
    recaptchaTerms: 'Terms',
    disclaimer:
      'GMG Automation is neither an authorized distributor nor an authorized representative of the brands mentioned on this website. The trademarks and names cited on this website belong to their respective owners.',
  },

  common: {
    noResults: 'No results',
  },

  validation: {
    required: 'This field is required',
    emailInvalid: 'Please enter a valid email address',
    tooLong: 'This field must not exceed {max} characters',
    recaptchaError: 'reCAPTCHA verification failed. Please try again.',
  },

  seo: {
    home: {
      title: 'GMG Automation — Industrial Automation Spare Parts',
      description: 'Find obsolete and current industrial automation spare parts. Search by part number and request a quote within 24 hours. Controllers, PLCs, HMIs, servo drives and more.',
    },
    manufacturers: {
      title: 'Manufacturers — GMG Automation',
      description: 'Browse automation spare parts by manufacturer. Siemens, ABB, Schneider Electric, Fanuc and hundreds more. Fast worldwide shipping with 12-month warranty.',
    },
    about: {
      title: 'About Us — GMG Automation',
      description: 'Over 10 years of experience in industrial automation spare parts. Multilingual team, global supplier network, fast response and 12-month warranty on all parts.',
    },
    blog: {
      title: 'Blog — GMG Automation',
      description: 'Stay up to date with the latest news, industry insights and technical articles from the GMG Automation team.',
    },
    faq: {
      title: 'FAQ — GMG Automation',
      description: 'Answers to frequently asked questions about ordering spare parts, shipping, payment and warranty at GMG Automation.',
    },
    contact: {
      title: 'Contact Us — GMG Automation',
      description: 'Get in touch with the GMG Automation team. Call us, send an enquiry form or message us directly. We respond within 24 hours.',
    },
    terms: {
      title: 'Terms & Conditions — GMG Automation',
      description: 'Read the terms and conditions governing the use of GMG Automation services and the purchase of industrial spare parts.',
    },
    privacy: {
      title: 'Privacy Policy — GMG Automation',
      description: 'Learn how GMG Automation collects, uses and protects your personal data in accordance with applicable privacy regulations.',
    },
    cookie: {
      title: 'Cookie Policy — GMG Automation',
      description: 'Learn about the cookies used on the GMG Automation website and how to manage your preferences.',
    },
    product: {
      description: 'Buy {partNumber} by {manufacturer}. Request a quote for fast worldwide delivery. 12-month warranty included.',
    },
    manufacturerProducts: {
      description: 'Browse {manufacturer} spare parts and automation components. Search by part number and request a quote with fast worldwide delivery.',
    },
  },
}
